import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
/**
 * React Router doesn't reset scroll position on navigation. Without this, a page
 * opened while scrolled down (e.g. the footer's "Terms of Service" link) renders
 * with the previous page's scroll offset still applied.
 *
 * Keyed on `pathname` only — a `search`-only change (e.g. `/permits/portal/details?viewDetails=...`)
 * keeps the current scroll position instead of yanking it back to top.
 */
export function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}
